"use client";

import React from "react";
import { Facebook, Instagram, MessageCircle } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const socialLinks = [{
  name: "Facebook",
  icon: Facebook,
  url: "https://www.facebook.com/borellisindaco"
}, {
  name: "Instagram",
  icon: Instagram,
  url: "https://instagram.com"
}, {
  name: "WhatsApp",
  icon: MessageCircle,
  url: "https://whatsapp.com"
}];
export default function SocialConnect() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="socialconnect" className="bg-background py-16 md:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="container mx-auto max-w-2xl">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="p-8 md:p-12 text-center shadow-lg border-border/40 bg-card">
            <h2 className="text-primary font-default font-bold text-2xl md:text-3xl mb-8 tracking-tight">
              Seguici sui social
            </h2>
            
            <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6">
              {socialLinks.map((social, i) => <Button key={social.name} data-index={i} asChild variant="outline" size="icon" className="size-14 md:size-16 rounded-lg border-2 border-primary/10 text-primary bg-background hover:border-secondary hover:bg-secondary hover:text-secondary-foreground hover:scale-110 transition-all duration-300 shadow-sm hover:shadow-md">
                  <Link to={social.url} newTab aria-label={`Visita la nostra pagina ${social.name}`}>
                    <social.icon className="size-6 md:size-7" />
                  </Link>
                </Button>)}
            </div>
          </Card>
        </div>
      </div>
    </section>;
}